import { useEffect } from "react";
import "./modalAd.css";

const ModalAd = (props) => {
    useEffect(() => {
       window.addEventListener('load', function (){
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        })
        let adCont = document.querySelector('.adsbygoogle')

        const id = setInterval(triggerInterval, 100)

        function triggerInterval() {
            if (adCont) {
                document.querySelector('.ad-contTT').querySelector('.adsbygoogle').style.height = "730px";
                clearInterval(id)
            }

        }


    return () => {
        clearInterval(id);
    };

    }, []);

    return (
        <div className="ad-contTT">
            <ins
                className="adsbygoogle"
                data-ad-client="ca-pub-7894154869919315"
                data-ad-format="auto"
                data-ad-slot="7987832891"
                data-full-width-responsive="true"
                style={{ display: "inline-block", width: "802px", height: "500px", position: "sticky" }}
            />
        </div>
    );
};
export default ModalAd;
